import * as React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';
import { DirectoryContactForm } from './DirectoryContactForm';
import useAdmin from '../hooks/useAdmin';

export const DirectoryContactCreate = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.directorycontacts.notification.created', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Contact' }
        });
        redirect('/directorycontacts');
    };

    useAdmin();

    return (
        <Create title="Create Directory Contact" {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <DirectoryContactForm isEdit={false} />
        </Create>
    );
};

export default DirectoryContactCreate;
